// resources/js/woocommerce/archive/attrFilters.js
// WooCommerce Archive – Attribute filters (checkboxes -> CSV in hidden input)
// - Pure vanilla JS (geen jQuery)
// - Autosubmit ALLEEN als het formulier data-autosubmit heeft

export function mount() {
  // Guard tegen dubbel initialiseren
  if (window.__wkAttrFiltersBooted) return;
  window.__wkAttrFiltersBooted = true;

  // Helper: update hidden "filter_{attr}" gebaseerd op alle checked checkboxes in dezelfde widget
  function updateHiddenFromWidget(widgetEl) {
    if (!widgetEl) return;
    const form = widgetEl.querySelector('.wk-attr-form');
    if (!form) return;

    // Vind de hidden input "filter_*"
    const hidden = form.querySelector('input[name^="filter_"]');
    if (!hidden) return;

    // Verzamel alle geselecteerde slugs uit dit widget
    const checked = Array.from(widgetEl.querySelectorAll('.wk-attr__chk:checked'))
      .map((el) => String(el.value || '').trim())
      .filter(Boolean);

    hidden.value = checked.join(',');
    return form;
  }

  // Delegated change-handler: werkt ook bij late injectie
  document.addEventListener(
    'change',
    (e) => {
      const chk = e.target.closest('.wk-attr__chk');
      if (!chk) return;

      // Zoek het omvattende widget (heeft normaliter .widget en data-attr)
      const widget = chk.closest('.widget');
      const form = updateHiddenFromWidget(widget);

      // Alleen autosubmit als expliciet aangezet (sidebar/desktop)
      if (form && form.hasAttribute('data-autosubmit')) {
        try {
          form.submit();
        } catch (err) {
          console.error('[attrFilters] autosubmit failed:', err);
        }
      }
    },
    { passive: true }
  );

  // Veiligheidsnet: voorkom native submit als data-autosubmit ontbreekt
  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target.closest('.wk-attr-form');
      if (!form) return;
      if (!form.hasAttribute('data-autosubmit')) {
        // In off-canvas willen we nooit auto-submits
        e.preventDefault();
      }
    },
    { capture: true }
  );
}
